import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException, resolveContent } from '@nu-art/ts-common';
import { AccessLevel } from '../modules/ModuleFE_PermissionsAssert.js';
export class Component_SwitchView extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.mode = nextProps.mode;
        state.modes = nextProps.modes;
        return state;
    }
    // ######################## Logic ########################
    getModeForKey = (key) => {
        const mode = this.state.modes.find(mode => mode.key === key);
        if (!mode)
            throw new BadImplementationException(`No mode found for given key ${key}`);
        return mode;
    };
    // ######################## Render ########################
    render() {
        const mode = this.getModeForKey(this.state.mode);
        if (!mode.permissionKey)
            return resolveContent(mode.renderer);
        const accessLevel = mode.permissionKey.getAccessLevel();
        if (accessLevel === AccessLevel.Undefined) {
            this.logError(`Data for permission key ${mode.permissionKey.key} does not exist`);
            return;
        }
        if (accessLevel < AccessLevel.HasAccess)
            return;
        return resolveContent(mode.renderer);
    }
}
//# sourceMappingURL=Component_SwitchView.js.map